export enum ETransactionType {
  SUBSCRIPTION = 'SUBSCRIPTION',
  CONSUME = 'CONSUME',
  SUBSCRIPTION_WITH_CONSUME = 'SUBSCRIPTION_WITH_CONSUME',
  CONSUME_PRE_CANCELLATION = 'CONSUME_PRE_CANCELLATION',
  CONSUME_PRE_PLAN_SWITCH = 'CONSUME_PRE_PLAN_SWITCH',
}
